import LangSelector from '../LangSelector/LangSelector';
import styles from './NavMenu..module.css';
import { Link, useLocation } from 'react-router-dom';
import NavIcons from '../NavIcons/NavIcons';
import { useTranslation } from 'react-i18next';

const NavMenu = ({
  menuSmall = '',
  menuMiddle = '',
  menuBig = '',
  menuOpen,
}) => {
  const { t } = useTranslation();

  const navMenuInfo = [
    { link: '/', class: styles.menuSmallItem, name: t('lang.menuHome') },
    { link: '/work', class: styles.menuSmallItem, name: t('lang.menuWork') },
    { link: '/about', class: styles.menuSmallItem, name: t('lang.menuAbout') },
    {
      link: '/contact',
      class: styles.menuSmallItem,
      name: t('lang.menuContact'),
    },
  ];

  const location = useLocation();

  const handleBurgerClick = () => {
    menuOpen(false);
  };

  const isLinkActive = (path) => {
    // Compare the current location pathname with the link path
    return location.pathname === path;
  };
  // const [selectedLang, setSelectedLang] = useState('English');

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);

  return (
    <>
      {menuSmall && (
        <nav className={styles.menuSmall}>
          {navMenuInfo?.map((item, idx) => (
            <Link
              key={idx}
              // className={item.menuSmallItem}

              className={`${styles.menuItem} ${
                isLinkActive(item.link) ? styles.active : ''
              }`}
              to={item.link}
              onClick={handleBurgerClick}
            >
              {item.name}
            </Link>
          ))}

          <LangSelector menuSmall='1' />

          <NavIcons />
        </nav>
      )}

      {menuMiddle && (
        <nav className={styles.menuMiddle}>
          {navMenuInfo?.map((item, idx) => (
            <Link
              key={idx}
              className={`${styles.menuItem} ${
                isLinkActive(item.link) ? styles.active : ''
              }`}
              to={item.link}
            >
              {item.name}
            </Link>
          ))}

          {/* <Link className={`${(styles.menuItem, styles.active)}`} to="/">
            Home
          </Link> */}

          {/* <Link className={styles.menuItem} to="/work">
            Work
          </Link>

          <Link className={styles.menuItem} to="/about">
            About
          </Link>

          <Link className={styles.menuItem} to="/contact">
            Contact
          </Link> */}
          <LangSelector menuMiddle='1' />
        </nav>
      )}

      {menuBig && (
        <nav className={styles.menuBig}>
          {navMenuInfo?.map((item, idx) => (
            <Link
              key={idx}
              className={`${styles.menuItem} ${
                isLinkActive(item.link) ? styles.active : ''
              }`}
              to={item.link}
            >
              {item.name}
            </Link>
          ))}

          {/* <Link className={styles.menuItem} to="/">
            Home
          </Link>

          <Link className={styles.menuItem} to="/work">
            Work
          </Link>

          <Link className={styles.menuItem} to="/about">
            About
          </Link>

          <Link className={styles.menuItem} to="/contact">
            Contact
          </Link> */}
          <LangSelector menuMiddle='1' />
        </nav>
      )}
    </>
  );
};

export default NavMenu;
